module.exports = __webpack_public_path__ + "static/img/Sapre.c8be90a3.png";